import { extend } from 'flarum/common/extend';
import app from 'flarum/forum/app';
import Button from 'flarum/common/components/Button';
import IndexPage from 'flarum/forum/components/IndexPage';

/**
 * 桌面端：索引页侧栏，与同页的「发布主题」「签到」一致的主按钮布局（App-primaryControl），配色见 forum.less。
 */
export default function registerIndexSidebar() {
  app.initializers.add('acme-pku-badminton-index-sidebar', () => {
    extend(IndexPage.prototype, 'sidebarItems', function (items) {
      items.add(
        'acmeBadmintonTradesNav',
        <Button
          icon="fas fa-table-tennis"
          className="Button Button--block BadmintonTrades-sidebarButton"
          itemClassName="App-primaryControl"
          onclick={() => m.route.set(app.route('acme.badminton.trades'))}
        >
          {app.translator.trans('acme-pku-badminton.forum.nav_trades')}
        </Button>,
        49
      );
    });
  });
}
